import { render, staticRenderFns } from "./RewardAdd.vue?vue&type=template&id=4ee2c112&scoped=true"
import script from "./RewardAdd.vue?vue&type=script&lang=js"
export * from "./RewardAdd.vue?vue&type=script&lang=js"
import style0 from "./RewardAdd.vue?vue&type=style&index=0&id=4ee2c112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2c112",
  null
  
)

export default component.exports